import Vue from 'vue';
import ProductPrices from './components/ProductPrices.vue';

function mountProductPrices() {
  var mountElements = document.querySelectorAll('.product-prices-mount:not([data-v-app])');

  mountElements.forEach(function(mountEl) {
    mountEl.setAttribute('data-v-app', 'true');

    var rawData = mountEl.getAttribute('data-config');
    var parsedData = null;

    if (rawData) {
      try {
        parsedData = JSON.parse(rawData);
      } catch (e) {
        console.error('Failed to parse product-prices data:', e);
      }
    }

    new Vue({
      render: function(h) {
        return h(ProductPrices, {
          props: {
            initialData: parsedData
          }
        });
      }
    }).$mount(mountEl);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountProductPrices);
} else {
  mountProductPrices();
}

if (window.jQuery) {
  window.jQuery(window).on('elementor/frontend/init', function() {
    if (window.elementorFrontend && window.elementorFrontend.hooks) {
      window.elementorFrontend.hooks.addAction('frontend/element_ready/ka_product_prices.default', function() {
        mountProductPrices();
      });
    }
  });
}

if (typeof MutationObserver !== 'undefined') {
  var observer = new MutationObserver(function(mutations) {
    var shouldMount = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList && node.classList.contains('product-prices-mount') || node.querySelector && node.querySelector('.product-prices-mount'))) {
            shouldMount = true;
          }
        });
      }
    });
    if (shouldMount) {
      mountProductPrices();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
